import { Socket } from "./Socket";
export class ArrayBuffer extends Socket {
    processReceived(data) {
        return data?.arrayBuffer
            ? data.arrayBuffer()
            : typeof data == "string"
                ? new TextEncoder().encode(data).buffer
                : data;
    }
    processSend(data) {
        return data;
    }
}
//# sourceMappingURL=ArrayBuffer.js.map